var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-head"},[_c('v-card',{staticClass:"page_head__card text-center",attrs:{"color":"primary"}},[_c('h4',{staticClass:"text-h4 font-weight-bold"},[_vm._v("FIND EVERYTHINGS YOU WANT ?")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }